/* global axios */
import ApiClient from './ApiClient';

// Client for the premium overlay's account-scoped billing endpoints
// (custom/ routes: /api/v1/accounts/:accountId/...).
class PlanAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getEntitlements() {
    return axios.get(`${this.url}entitlements`);
  }

  getPlans() {
    return axios.get(`${this.url}plans`);
  }

  getSubscription() {
    return axios.get(`${this.url}subscription`);
  }

  checkout(planSlug, successUrl, cancelUrl) {
    return axios.post(`${this.url}billing/checkout`, {
      plan_slug: planSlug,
      success_url: successUrl,
      cancel_url: cancelUrl,
    });
  }

  portal(returnUrl) {
    return axios.post(`${this.url}billing/portal`, { return_url: returnUrl });
  }
}

export default new PlanAPI();
